import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faStar } from "@fortawesome/free-solid-svg-icons";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Form, InfoPopup } from "../../components";
import { VoucherRevokeType } from "../../enums";
import { VoucherRevokePerks } from "../../types";
import { POSSIBLE_CHOICES, POSSIBLE_CHOICES_LABELS } from "./constants";
import { getMobilePerkValue, possiblePerkFilter } from "./utils";
import "./MobilePerksMatrix.scss";

interface Props {
  onChangeType(type: VoucherRevokeType): void;
  selectedType?: VoucherRevokeType;
  voucherRevokePerks: VoucherRevokePerks;
}

const MobilePerksMatrix = ({
  onChangeType,
  voucherRevokePerks,
  selectedType,
}: Props) => {
  const { t } = useTranslation();

  const voucherFaqUrl = useMemo(() => {
    const label = t("faq_page_url_voucher");
    return !!label && label !== "faq_page_url_voucher" ? label : undefined;
  }, [t]);

  return (
    <div className="mobile-perks-matrix">
      {POSSIBLE_CHOICES.map((possibleChoice, index) => (
        <div
          className={`perks-item ${index === 0 ? "most-popular" : ""}`}
          key={index}
          onClick={() => onChangeType(possibleChoice)}
        >
          {index === 0 && <div className="ribbon">{t("lp_most_chosen")}</div>}
          <div className="title">
            <div className="title__content">
              <span>{t(POSSIBLE_CHOICES_LABELS[possibleChoice])}</span>
              {Array(POSSIBLE_CHOICES.length - index)
                .fill(null)
                .map((_, starIndex) => (
                  <FontAwesomeIcon
                    color="#fcc001"
                    icon={faStar}
                    key={starIndex}
                  />
                ))}
            </div>
          </div>
          <ul className="perks-list">
            {voucherRevokePerks.perks
              .filter(possiblePerkFilter(possibleChoice))
              .map((perk, perkIndex) => {
                const perkValue = getMobilePerkValue(possibleChoice)(perk);
                return (
                  <li key={`${index}-${perkIndex}`} style={{ display: "flex" }}>
                    <FontAwesomeIcon color="#7EB441" icon={faCheck} />
                    <div>
                      <span>
                        {t(perk.title)}
                        {perkValue && (
                          <strong
                            style={{ fontWeight: 500 }}
                          >{` ${perkValue}`}</strong>
                        )}
                      </span>
                      {perk.description && (
                        <InfoPopup>{t(perk.description)}</InfoPopup>
                      )}
                    </div>
                  </li>
                );
              })}
          </ul>
          <div>
            <Form.RadioField
              checked={possibleChoice === selectedType}
              name="cancellationType"
              onChange={(event) =>
                onChangeType(event.target.value as VoucherRevokeType)
              }
              value={possibleChoice}
            />
          </div>
          {index === 0 && voucherFaqUrl && (
            <div className="voucher-faq">
              <a href={voucherFaqUrl}>{t("lp_voucher_faq")}</a>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default MobilePerksMatrix;
